import { NgModule } from "@angular/core";
import { NoSpecialCharactersDirective } from "./no-special-characters.directive";



@NgModule({
  declarations: [NoSpecialCharactersDirective],
  exports: [NoSpecialCharactersDirective]
})
export class NoSpecialCharactersModule { }
